import CityScape from './city_night.jpg'
import Hearts from './hearts.png'
import Meadow from './grassy_meadow.jpg'
import Hearts2 from './hearts2.png'
import Purple from './purple.jpg'
import YourLossBabe from './your_loss_babe.png'

const BANNERS = [
    CityScape,
    Hearts,
    Meadow,
    Hearts2,
    Purple,
    YourLossBabe
]

export default BANNERS